import { useAtomValue } from 'jotai'
import { sidebarOpenAtom } from '../state/store'
import { useMobile } from '../hooks/useMobile'
import { cn } from '@neo-agents/ui'
import { RobotLogo } from './RobotLogo'

interface SidebarProps {
  title?: string
  children: React.ReactNode
}

export function Sidebar({ title, children }: SidebarProps) {
  const sidebarOpen = useAtomValue(sidebarOpenAtom)
  const isMobile = useMobile()

  return (
    <aside
      className={cn(
        'h-full shrink-0 border-r-2 border-nb-border bg-sidebar flex flex-col transition-all duration-200 overflow-hidden',
        isMobile
          ? 'absolute left-0 top-0 z-40 nb-shadow'
          : '',
        sidebarOpen ? 'w-[280px]' : 'w-0 border-r-0',
      )}
    >
      <div className="flex h-12 items-center justify-between px-4 border-b-2 border-nb-border shrink-0">
        <div className="flex min-w-0 items-center gap-2">
          <RobotLogo className="h-7 w-7" />
          <span className="font-heading text-sm truncate">
            {title ?? 'Robolab X'}
          </span>
        </div>
      </div>
      <div className="flex-1 flex flex-col min-h-0">
        {children}
      </div>
    </aside>
  )
}
